import { SettingsButton, TxDeadlineSetting } from '@/components/common/Settings/index';

import { ADD_LIQUIDITY_SETTINGS_KEYS } from '@/components/common/Settings/settingKeys';

function EditAddLiquiditySettings() {
  return (
    <SettingsButton title="Add Liquidity Settings" testID="add-liquidity-settings">
      <TxDeadlineSetting
        label="Transaction deadline"
        settingKey={ADD_LIQUIDITY_SETTINGS_KEYS.TX_DEADLINE}
      />
    </SettingsButton>
  );
}

export { EditAddLiquiditySettings };
